<div id="appRoot">
    <router-outlet></router-outlet>
</div>